import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { applyEnvironmentWatermark } from '@/common/lib/environmentWatermark'
import '@/common/styles/environmentWatermark.css'
import App from './app/index.tsx'
import './app/styles/index.css'

applyEnvironmentWatermark()

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter
            future={{
                v7_startTransition: true,
            }}
        >
            <App />
        </BrowserRouter>
    </React.StrictMode>
)
